export default __webpack_public_path__ + "static/media/bg-1600.4a571d7b.jpeg";